export const taillight = [1.7, 0.06, 0.05];
